module.exports = __webpack_public_path__ + "img/logo-pse.53ff8d88.svg";